<template>
  <Row>
    <Col span="12">
      <Input v-model="searchName" placeholder="请输入名称" class="public-inp" />
      <Button
        type="primary"
        icon="md-search"
        @click="getList()"
        v-access="'labelInfo.query'"
        >搜索</Button
      >
      <Button @click="resetList()" v-access="'labelInfo.reset'">重置</Button>
    </Col>
    <Col span="12">
      <Button
        type="primary"
        icon="md-add"
        class="public-fr"
        v-access="'labelInfo.add'"
        @click="openFn()"
        >添加标签</Button
      >
    </Col>
    <Col span="24">
      <Table
        :style="{ marginTop: '10px' }"
        border
        stripe
        :loading="loading"
        :columns="columns"
        :data="tbList"
      >
        <template slot-scope="{ row, index }" slot="sort">
          <span v-show="false">{{ row.code }}</span>
          {{ (page - 1) * pageSize + index + 1 }}
        </template>
        <template slot-scope="{ row, index }" slot="status">
          <i-switch
            v-access="'labelInfo.status'"
            :value="row.status == 0"
            @on-change="(v) => stateChange(v, row, index)"
            size="small"
          />
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a
            href="javascript:;"
            @click="openFn(row, index)"
            v-access="'labelInfo.edit'"
            >编辑</a
          >
          <a
            href="javascript:;"
            @click="removeFn(index, row)"
            v-access="'labelInfo.delete'"
            >删除</a
          >
        </template>
      </Table>
      <Page
        :total="total"
        :page-size="pageSize"
        :current="page"
        show-sizer
        show-total
        prev-text="上一页"
        next-text="下一页"
        @on-change="pageChange"
        @on-page-size-change="pageSizeChange"
        class="public-page"
      />
    </Col>
    <!-- 编辑 -->
    <Modal
      v-model="formModel"
      :title="formTitle == 0 ? '新增标签' : '编辑标签'"
      :loading="formModalLoading"
      :mask-closable="false"
      @on-ok="addAction"
      @on-cancel="cancelAction"
    >
      <Form
        ref="formValidate"
        :model="formItem"
        :rules="ruleValidate"
        :label-width="80"
      >
        <FormItem label="名称" prop="name">
          <Input v-model="formItem.name" placeholder="请输入名称"></Input>
        </FormItem>
        <FormItem label="描述">
          <Input
            v-model="formItem.remark"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            placeholder="请输入描述"
          ></Input>
        </FormItem>
      </Form>
    </Modal>
  </Row>
</template>
<script>
const columns = [
  {
    title: "序号",
    slot: "sort",
    width: 60,
  },
  {
    title: "标签名称",
    key: "name",
  },
  {
    title: "标签描述",
    key: "remark",
  },
  {
    title: "创建日期",
    key: "createtime",
  },
  {
    title: "修改日期",
    key: "updatetime",
  },
  {
    title: "状态",
    slot: "status",
  },
  {
    title: "操作",
    slot: "action",
    width: 150,
  },
];
export default {
  data() {
    return {
      loading: false,
      columns,
      tbList: [],
      searchName: "",
      page: 1,
      pageSize: 10,
      total: 0,
      formModel: false,
      formModalLoading: true,
      formTitle: 0,
      formItemCode: "",
      formItem: {
        name: "",
        remark: "",
      },
      uploadPram: {
        scene: "SHOP",
      },
      uploading: false,
      ruleValidate: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 列表
    getList() {
      let data = {
        name: this.searchName,
        page: this.page,
        pageSize: this.pageSize,
      };
      this.loading = true;
      this.$api.labelPage(data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          let list = res.data;
          if (!list || list.length == 0) {
            this.tbList = [];
            return;
          }
          this.tbList = list;
          this.total = res.total;
        }
      });
    },
    // 页码
    pageChange(d) {
      this.page = d;
      this.getList();
    },
    // 页数
    pageSizeChange(d) {
      this.pageSize = d;
      this.getList();
    },
    // 重置
    resetList() {
      this.searchName = "";
      this.page = 1;
      this.pageSize = 10;
      this.$nextTick(() => {
        this.getList();
      });
    },
    // 打开新增编辑
    openFn(d, i) {
      let that = this;
      this.formTitle = d ? 1 : 0;
      if (d) {
        this.formItem = { name: d.name, remark: d.remark };
        this.formItemCode = d.code;
      } else {
        this.formItem = { name: "", remark: "" };
        this.formItemCode = "";
      }
      this.$nextTick(() => {
        that.formModel = true;
      });
    },
    // 新增编辑确定
    addAction() {
      let data = this.formItem;
      let http = "labelAdd";
      this.$refs["formValidate"].validate((valid) => {
        if (valid) {
          if (this.formTitle == 1) {
            data.code = this.formItemCode;
            http = "labelUpdate";
          }
          this.$api[http](data).then((res) => {
            if (res.code == "200") {
              this.$Message.success("操作成功");
              this.cancelAction();
              this.getList();
            }
          });
        }
      });
      this.formModalLoading = false;
      this.$nextTick(() => {
        this.formModalLoading = true;
      });
    },
    cancelAction() {
      this.$refs["formValidate"].resetFields();
      this.formModel = false;
    },
    // 删除部门
    removeFn(i, d) {
      this.$Modal.confirm({
        title: "提示",
        content: `确认删除${d.name}`,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          this.$api.labelDelete({ code: d.code }).then((res) => {
            if (res.code == "200") {
              this.$Message.success("删除成功");
              this.getList();
            }
          });
        },
      });
    },
    // 状态
    stateChange(v, d, i) {
      let http = d.status == 0 ? "labelDisable" : "labelEnable";
      this.$api[http]({ code: d.code }).then((res) => {
        if (res.code == "200") {
          this.$Message.success(v ? "启用成功" : "禁用成功");
          this.getList();
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/commodity/labelInfo.vue